module.exports = __webpack_public_path__ + "img/home-5.81cd3eaa.webp";